webpackJsonp([12],{

/***/ "7Otq":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo.a5ba852.png";

/***/ }),

/***/ "7yX/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BaseMainMenu_vue__ = __webpack_require__("rSAv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67b43516_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BaseMainMenu_vue__ = __webpack_require__("cCwy");
function injectStyle (ssrContext) {
  __webpack_require__("eyuN")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BaseMainMenu_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67b43516_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BaseMainMenu_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Du/2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET_CONTENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SET_PROGRAM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SET_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SET_CONTEST_MSG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SET_VOLUNTAR_FORM_STATE; });
var SET_CONTENT = 'SET_CONTENT';
var SET_PROGRAM = 'SET_PROGRAM';
var SET_MODAL = 'SET_MODAL';
var SET_CONTEST_MSG = 'SET_CONTEST_MSG';
var SET_VOLUNTAR_FORM_STATE = 'SET_VOLUNTAR_FORM_STATE';

/***/ }),

/***/ "IcnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mutation_types__ = __webpack_require__("Du/2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store_moderator__ = __webpack_require__("Pj5g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_es6_promise_auto__ = __webpack_require__("MU8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_es6_promise_auto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_es6_promise_auto__);



var _mutations;










__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* default */]);

var state = {
  language: {
    select: ['RO', 'EN']
  },
  isContestUploadSuccess: false,
  isModal: false,
  content: {
    RO: {
      menu: {
        // about: 'despre',
        concurs: 'concursuri',
        invitati: 'invitați',
        program: 'program',
        streetart: 'streetart',
        // voluntar: 'voluntari',
        parteneri: 'parteneri',
        echipa: 'echipă',
        press: 'press',
        archive: 'arhivă',
        contact: 'contact'
      },
      home: {
        title: 'Blecher Fest 2018',
        subTitle: '25 - 27 Mai / Roman - ediția a II-a',
        description: 'Blecher Fest - festival de literatura si cultura, ce il celebreaza pe scriitorul Max Blecher.'
      },
      contest: {
        title: 'Concursuri:',
        description: 'Anul acesta, Blecher Fest propune trei concursuri pentru urm\u0103toarele sec\u021Biuni:\n                    proz\u0103, poezie \u0219i art\u0103 fotografic\u0103. <br><br> Tema general\u0103 este:',
        juriu: {
          description: 'Juriul este format din:',
          sections: [{
            name: 'proză:',
            juriu: [{
              name: 'Alain Gavriluțiu',
              pic: 'http://www.hergbenet.ro/wp-content/uploads/2014/04/alain-gavrilutiu-2.jpg',
              link: 'http://www.humanitas.ro/alain-gavrilutiu'
            }, {
              name: 'Cosmin Perța',
              pic: 'https://upload.wikimedia.org/wikipedia/commons/b/ba/Cosmin-Perta.jpg',
              link: 'https://ro.wikipedia.org/wiki/Cosmin_Per%C8%9Ba'
            }, {
              name: 'Sorin Mihai Grad',
              pic: 'http://www.hergbenet.ro/wp-content/uploads/2013/12/Sorin_Mihai_Grad.jpg',
              link: 'http://www.hergbenet.ro/autor/sorin-mihai-grad-2'
            }]
          }, {
            name: 'poezie:',
            juriu: [{
              name: 'Teodor Dună',
              pic: 'https://upload.wikimedia.org/wikipedia/commons/b/b7/Teodor_duna.jpg',
              link: 'https://ro.wikipedia.org/wiki/Teodor_Dun%C4%83'
            }, {
              name: 'Dan Coman',
              pic: 'http://blog.goethe.de/dlite/uploads/DanComan.jpg',
              link: 'https://ro.wikipedia.org/wiki/Dan_Coman'
            }, {
              name: 'Elena Vlădăreanu',
              pic: 'http://www.agentiadecarte.ro/wp-content/uploads/2016/06/elena-vladareanu-foto-filb.jpg',
              link: 'https://ro.wikipedia.org/wiki/Elena_Vl%C4%83d%C4%83reanu'
            }]
          }, {
            name: 'artă fotografică:',
            juriu: [{
              name: 'Ionuț Pițurescu',
              pic: 'https://www.berlinale-talents.de/bt/photos/000/033/33785_normal.jpg',
              link: 'https://ro.linkedin.com/in/ionut-piturescu-b9814465'
            }, {
              name: 'Tudor Botezatu',
              pic: 'http://pustnik.com/uploads/participants/Tudor-Botezatu.jpg',
              link: 'https://vimeo.com/93789544'
            }, {
              name: 'Daniel Ionescu',
              pic: 'http://www.blecherfest.ro/pics/deni-profile.jpg',
              link: 'https://www.linkedin.com/in/daniel-ionescu-22550329/'
            }]
          }]
        },
        conditions: 'Pentru a participa, v\u0103 rug\u0103m s\u0103 citi\u021Bi cu aten\u021Bie\n                    regulamentul pentru fiecare sec\u021Biune, \u0219i apoi s\u0103 v\u0103 \xEEnscrie\u021Bi\n                    folosind formularul de mai jos.',
        themes: {
          proza: 'Timpul care nu s-a scurs \xEEnc\u0103'
        },
        rules: {
          poezie: [{
            name: 'Anexe proză și poezie',
            url: 'Anexa-1-si-2-Concursul-literar-Max-Blecher-2018.docx'
          }, {
            name: 'Regulament proză și poezie',
            url: 'Regulament-oficial-Concurs-literar-Max-Blecher-2018.docx'
          }],
          shortMovies: [{
            name: 'Anexe artă fotografică',
            url: 'Anexa-1-si-2-Concurs-arta-fotografica-Max-Blecher-2018.docx'
          }, {
            name: 'Regulament artă fotografică',
            url: 'Regulament-oficial-Concurs-arta-fotografica-Max-Blecher-2018.docx'
          }]
        },
        form: {
          name: 'Formular înscriere:',
          fields: {
            prenume: 'prenume',
            nume: 'nume',
            oras: 'oraș',
            email: 'email'
          },
          categories: {
            defaultName: 'Selectati sectiunea',
            sections: ['proza', 'poezie', 'artă fotografică']
          },
          upload: 'Atașați manuscrisul/fotografia și anexele completate (max. 2 fișiere - Anexa + Manuscris/Foto)',
          terms: 'Am citit si sunt de-acord cu regulamentul concursului',
          btn: 'TRIMITE'
        },
        uploadSuccess: 'Felicit\u0103ri, lucrarea ta a fost \xEEnregistrat\u0103 \xEEn concurs. \xCE\u021Bi dorim mult succes!',
        castigatori: {
          poezie: {
            I: ['Emilia Nedelcoff, Ia\u0219i', 'Emilia'],
            II: ['Vlad Serdarian, Bucure\u0219ti', 'Vlad'],
            III: ['Andreea Petrovici, Suceava', 'Andreea']
          },
          proză: {
            I: ['Matei B\u0103lan, Boto\u0219ani', 'Matei'],
            II: ['Andreea Alexandrina Lungu, Gala\u021Bi', 'Andreea'],
            III: ['C\u0103t\u0103lin Furtun\u0103, Bucure\u0219ti', 'Catalin']
          },
          'artă fotografică': {
            I: ['\u0218tefan Leonte, Roman', 'Stefan'],
            II: ['Iulia Diana Ro\u0219u, Nazna, jud. Mure\u0219', 'Iulia'],
            III: ['Sara Ple\u0219a Popescu, Deva', 'Sara']
          }
        }
      },
      archive: {
        title: 'Ediții anterioare:',
        editions: ['2017']
      },
      contact: {
        title: 'Adresează-ne o întrebare:',
        form: {
          name: 'nume',
          email: 'email',
          msg: 'mesaj'
        },
        btn: 'trimite'
      },
      press: [],
      voluntar: {
        categories: ['Biciclist (promovează festivalul pe bicicletă în Roman sau alte orașe din apropiere)', 'Tehnician (asistent pe echipamentele tehnice din cadrul festivalului)', 'Heirupist (partea logistică a festivalului)', 'Sociabil (relaționează cu invitații și participanții festivalului)']
      },
      invitati: [],
      program: {
        Vineri: [],
        Sambata: [],
        Duminica: []
      },
      echipa: [{
        nume: 'Irina Mihălcuț',
        rol: 'fondator',
        pic: 'irina.jpg'
      }, {
        nume: 'Alina Donosă',
        rol: 'comunicare',
        pic: 'alina.jpg'
      }, {
        nume: 'Andreea Olivia Farcaș',
        rol: 'logistică',
        pic: 'andreea.jpg'
      }, {
        nume: 'Doris Mironescu',
        rol: 'coordonator literar',
        pic: 'doris.jpg'
      }, {
        nume: 'Vasile Gherghel',
        rol: 'coordonator principal',
        pic: 'vasile.jpg'
      }, {
        nume: 'Ciprian Fechetă',
        rol: 'logistică',
        pic: 'ciprian.jpg'
      }, {
        nume: 'Sebastian Hrib',
        rol: 'logistică',
        pic: 'sebastian.jpg'
      }, {
        nume: 'Emilian Pal',
        rol: 'ambasador',
        pic: 'emilian.jpg'
      }],
      parteneri: {
        sponsor: [{
          nume: 'Primăria Municipiului Roman',
          pic: 'primariaRoman.jpg',
          url: 'http://www.primariaroman.ro/',
          type: 'sponsor'
        }, {
          nume: 'Casa Romașcană',
          pic: 'casa_romascana.jpg',
          url: 'https://casaromascana.com/',
          type: 'sponsor'
        }, {
          nume: 'Comunitatea Evreilor',
          pic: 'fcer.jpg',
          url: 'https://www.jewishfed.ro/',
          type: 'sponsor'
        }, {
          nume: 'BIZZ',
          pic: 'bizzonwheels.png',
          url: 'http://www.bizzonwheels.com/',
          type: 'sponsor'
        }, {
          nume: 'PIZZA21',
          pic: 'pizza-21.png',
          url: 'https://www.facebook.com/PIZZA-21-1299871430040030/?rf=143423106078532',
          type: 'sponsor'
        }, {
          nume: 'Nemteana',
          pic: 'nemteana.png',
          url: 'http://www.nemteana.ro/',
          type: 'sponsor'
        }, {
          nume: 'Farcas',
          pic: 'farcas.jpg',
          url: '#',
          type: 'sponsor'
        }, {
          nume: 'Fereastra-1',
          pic: 'fereastra-1.jpg',
          url: 'https://fereastra1.ro/',
          type: 'sponsor'
        }, {
          nume: 'Sense',
          pic: 'sense.jpg',
          url: 'http://fashionsense.ro/',
          type: 'sponsor'
        }, {
          nume: 'Bacania cu Dichis',
          pic: 'bacania.jpg',
          url: 'https://web.facebook.com/BacaniaCuDichisRoman',
          type: 'sponsor'
        }, {
          nume: 'TE-ROX',
          pic: 'te-rox.jpg',
          url: '',
          type: 'sponsor'
        }],
        partener: [{
          nume: 'Flanders Literature',
          pic: 'flanders.jpg',
          url: 'https://www.flandersliterature.be/',
          type: 'partener'
        }, {
          nume: 'Teatru Gong',
          pic: 'gong.jpg',
          url: 'https://www.facebook.com/Trupa-De-Teatru-Gong-466996656701035/',
          type: 'partener'
        }, {
          nume: 'PerfectKLIK',
          pic: 'PK.png',
          url: 'https://www.perfectklik.com/ro/',
          type: 'partener'
        }, {
          nume: 'BursaBinelui',
          pic: 'bursaBinelui.png',
          url: 'https://www.bursabinelui.ro/BursaBinelui/Proiecte/Blecher-Fest-2018',
          type: 'partener'
        }, {
          nume: 'Biblioteca',
          pic: 'biblioteca.jpg',
          url: '#',
          type: 'partener'
        }, {
          nume: 'Asoc Musatinii',
          pic: 'musatinii.jpg',
          url: 'https://musatinii.wordpress.com/',
          type: 'partener'
        }, {
          nume: 'Kult',
          pic: 'kult_hub.png',
          url: 'http://www.kulthub.ro/',
          type: 'partener'
        }, {
          nume: 'MUNAY',
          pic: 'munay.png',
          url: 'http://munaylife.ro/',
          type: 'partener'
        }, {
          nume: 'TDL',
          pic: 'tdl.jpg',
          url: 'http://thedigitallabs.com/',
          type: 'partener'
        }, {
          nume: 'UNYOUTH',
          pic: 'un_youth.jpg',
          url: 'https://www.facebook.com/unyouthroman/',
          type: 'partener'
        }, {
          nume: 'AsAdv',
          pic: 'asadvertising.png',
          url: 'http://asadvertising.ro/',
          type: 'partener'
        }, {
          nume: 'jews',
          pic: 'jews.jpg',
          url: '#',
          type: 'partener'
        }],
        media: [{
          nume: 'Top All',
          pic: 'topall.jpg',
          url: 'http://tvtopall.ro/',
          type: 'media'
        }, {
          nume: 'OK',
          pic: 'ok.jpg',
          url: 'http://revistaok.com/',
          type: 'media'
        }, {
          nume: 'BOOKAHOLIC',
          pic: 'bookaholic.png',
          url: 'http://bookaholic.ro/',
          type: 'media'
        }, {
          nume: 'ObservatorCultural',
          pic: 'observator.jpg',
          url: 'https://www.observatorcultural.ro/',
          type: 'media'
        }, {
          nume: 'TVR',
          pic: 'tvriasi.png',
          url: 'http://iasi.tvr.ro/',
          type: 'media'
        }]
      },
      bio: {
        'jan myskjin': 'Jan H. Mysjkin, n\u0103scut pe 16 noiembrie 1955 la Bruxelles, locuie\u015Fte din 1991 la Paris. Scrie at\xE2t \xEEn neerlandez\u0103, c\xE2t \u015Fi \xEEn francez\u0103. A publicat zece volume de poezie \xEEn neerlandez\u0103, printre care Rekenkunde van de tastzin (Aritmetica atingerii, tradus \xEEn rom\xE2n\u0103 de Baros/Mysjkin pentru Editura Exigent, 2012) sau Enz., enz\u2026 (\u015E.a.m.d., \u015F.a.m.d\u2026., tradus \xEEn rom\xE2n\u0103 de Ab\u0103lu\u0163\u0103/Mysjkin pentru Casa de Editur\u0103 Max Blecher, 2017). A tradus nenum\u0103rate texte scrise de autori clasici \u015Fi contemporani, at\xE2t poe\u0163i c\xE2t \u015Fi romancieri. \xCEn Belgia, transpunerile sale \xEEn neerlandez\u0103 au fost \xEEncununate cu \u201EPremiul Na\u0163ional pentru Traducere Literar\u0103\u201D (1990) \u015Fi, \xEEn \u0162\u0103rile de Jos, cu \u201EPremiul dr. Elly-Jaff\xE9\u201D (2012). \xCEn ultimii ani, a publicat peste optzeci de poe\u0163i \u015Fi prozatori rom\xE2ni \xEEn diferite reviste belgiene, neerlandeze \u015Fi franceze, \u015Fi \xEEn volum, pe autori precum Max Blecher, Mihail Sebastian, Nichita St\u0103nescu, Constantin Ab\u0103lu\u0163\u0103, Cristian Popescu, Daniel B\u0103nulescu \u015Fi Doina Ioanid. A alc\u0103tuit, de altfel, dou\u0103 antologii de poezie rom\xE2n\u0103 din perioada 1960-2010: Engel in het raam op het oosten (\xCEnger \xEEn fereastra dinspre r\u0103s\u0103rit, 2010) \u015Fi Voor de prijs van mijn mond (Cu pre\u0163ul gurii, 2013). \xCEn colaborare cu Doina Ioanid a publicat dou\u0103 antologii de poezie flamand\u0103 contemporan\u0103: Lumina ultimei zile (Casa de Editur\u0103 Max Blecher, 2014) \u015Fi Cu picioarele afar\u0103 (Editura ARC, 2016). A mai ap\u0103rut o selec\u0163ie de grote\u015Fti ale dadaistului flamand Paul van Ostaijen, Trustul patriotismului \u015Fi alte grote\u015Fti (Editura Paralela 45, 2016). Acela\u015Fi duo a realizat trei dosare cu poezia rom\xE2n\u0103 din Republica Moldova tradus\u0103 \xEEn francez\u0103 pentru revistele Po\xE9sie/premi\xE8re, Le Journal de Po\xE9sie \u015Fi L\u2019Intranquille. St\u0103 s\u0103 apar\u0103 c\xEEt de cur\xE2nd o antologie de poezie neerlandez\u0103 contemporan\u0103: Poetule, piapt\u0103n\u0103-\u0163i p\u0103rul! (Editura ARC, 2018).',
        'Doina Ioanid': 'Doina Ioanid (nume de scriitor), <br> Doina Ilie (nume civil) <br>\nScriitoare, traduc\u0103toare \u0219i jurnalist\u0103 <br>\nDoina Ioanid s-a n\u0103scut la 24 decembrie 1968, \xEEn Bucure\u015Fti. A absolvit Facultatea de Litere a Universit\u0103\u0163ii Bucure\u015Fti \xEEn 1995 \u015Fi cursurile de Master (Studii Culturale Franceze) la Facultatea de Limbi \u015Fi Literaturi Str\u0103ine a aceleia\u015Fi universit\u0103\u0163i, \xEEn 1998. A publicat poeme \xEEn volumul colectiv Ferestre \'98, girat de Mircea C\u0103rt\u0103rescu, Editura Aristarc, One\u015Fti, 1998, (\xEEmpreun\u0103 cu Ioana Vla\u015Fin, Cecilia \u015Etef\u0103nescu, Marius Ianu\u015F, Angelo Mitchievici, Iulian B\u0103icu\u0219 \u0219i Victor Nichifor). A participat la volumul experimental 40238 Tescani, Editura Image, Bucure\u015Fti, 2000 (al\u0103turi de Ioana Nicolaie, Marius Ianu\u015F, Domnica Drumea, Angelo Mitchievici, Mircea C\u0103rt\u0103rescu, Cecilia \u015Etef\u0103nescu \u015Fi Florin Iaru). A debutat individual cu un volum de poeme \xEEn proz\u0103: Duduca de mar\u0163ipan, Editura Univers, Bucure\u015Fti, 2000 (Premiul de debut \u201EPrima Verba\u201C). Au urmat alte volume de poezie: E vremea s\u0103 por\u0163i cercei, Editura Aula, Bra\u015Fov, 2001 (volum nominalizat la Premiile Aspro);  Cartea bur\u0163ilor \u015Fi a singur\u0103t\u0103\u0163ii, Pontica, Constan\u0163a, 2003; Poeme de trecere, Editura Vinea, Bucure\u0219ti, 2005; Audio-book Poeme de trecere, Editura ninpress, 2009; Ritmuri de \xEEmbl\xEEnzit aricioaica, Editura Cartea Rom\xE2neasc\u0103, Bucure\u0219ti, 2010 \u015Fi Cus\u0103turi, Editura Cartea Rom\xE2neasc\u0103, Bucure\u0219ti, 2014; Cele mai mici proze, Editura Nemira, Bucure\u0219;ti, 2017. Poemele sale au fost traduse \xEEn francez\u0103, maghiar\u0103, turc\u0103, sloven\u0103, bulgar\u0103, croat\u0103, german\u0103, neerlandez\u0103, englez\u0103, galez\u0103 \u015Fi polon\u0103, spaniol\u0103. Doina Ioanid a tradus din limba francez\u0103 mai multe c\u0103r\u021Bi, printre care: Marguerite Duras, Vara, la zece \u0219i jum\u0103tate seara \u2013 Editura Cartier, Chi\u015Fin\u0103u, 2006; Dai Sijie, \xCEntr-o noapte f\u0103r\u0103 lun\u0103 \u2013 Editura Polirom, Ia\u0219i, 2009; Karine Lambert, Femeile care au renun\u0163at la b\u0103rba\u0163i \u2013 Editura Trei, Bucure\u015Fti, 2015. <br>\n<br>\n<br>\n\nAteliere de traducere:  <br><br>\nArcu\u0219, 2006,  <br>\nICR Stockholm, Suedia, 2011 <br>\nAteliere de crea\u021Bie: Contes crois\xE9s \u2013 atelier europ\xE9en de formation aux arts du r\xE9cits, Pays de Thann, Fran\u021Ba, 2010 <br>\n\n<br>\n<br>\n \nBurse de crea\u0163ie:\n<br><br>\nICR Paris, 2007 <br>\nPEN Anvers, 2014, <br>\nFILIT, Ia\u0219i, 2017 <br>\nPassa Porta, Bruxelles, 2017 <br>\n\n<br><br>\n\nBurs\u0103 de traducere: <br>\n<br>\nLa Coll\xE8ge des traducteurs de Seneffe, 2016 <br>\n<br>\nParticip\u0103ri la festivaluri: <br>\n<br>\nFestivalul Interna\u0163ional de Poezie \u201EArs Amandi\u201C, Bra\u0219ov, 2005 <br>\nMaratonul de  Poezie, Sibiu, 2007 <br>\nFestivalul Interna\u0163ional de Poezie , Istanbul, 2009 <br>\nFestival Review of Small Literatures, Zagreb, 2010 <br>\nFestivalul de Poezie de la Bistri\u0163a, 2010 <br>\nDunya Festival, Rotterdam, 2011 <br>\nPoetry International Festival, Rotterdam, 2011 <br>\nPoetry Parnassus Festival, Londra, 2012 <br>\nBiennale Internationale de Po\xE9sie, Li\xE8ge, 2012 <br>\nFestivalul Interna\u0163ional de Poezie de la Sibiu, 2012 <br>\nFestivalul \u201EPoezia e la Bistri\u0163a\u201C, 2012 <br>\nSalon du Livre, Paris, 2013 <br>\nFelix Poetry Festival, Anvers, 2013 <br>\nLe Festival International de Po\xE9sie, Namur, 2013 <br>\nNorth Wales International Poetry Festival, 2013 <br>\nTranspo\xE9sie, Bruxelles, 2014 <br>\nLectures sous l\'Arbre, Ard\xE8che, Haute-Loire, 2015 <br>\nFestivalul Interna\u0163ional de Poezie  \u201EPrim\u0103vara European\u0103 a poe\u021Bilor\u201C, Chi\u0219in\u0103u, 2015, 2016, 2017 <br>\n\n<br><br>\n\nLucr\u0103ri proprii traduse \xEEn alte limbi: <br><br>\nA gy\xF6ny\xF6r roman m\xFAv\xE9szete/ Milionarii timpului, volum colectiv rezultat \xEEn urma unui atelier de traducere la Arcu\u0219. Traduceri de Bogd\xE1n L\xE1szlo, L\xF6vetei L\xE1z\xE1r L\xE1szlo,  S\xE1ntha Attila, Fekete Vincze, L\xE1szlo No\xE9mi, Editura Arcu\u015F, Arcu\u015F, 2006 <br>\n\xC7a\u011Fda\u0219 Romanya \u0218iiri (antologie), \xD6zg\xFCr Yayinlari, Ankara, 2009, 112 p., traducere \xEEn limba turc\u0103 de Sheilla Iaia <br>\nRevija malih knji\u017Eevnosti (antologie), Zagreb, 2010, 96 p., traducere \xEEn limba croat\u0103 de Ivana Oluji\u0107 <br>\n\u201EDriesch\u201C, nr. 4, decembrie 2010, Viena, traducere \xEEn limba german\u0103 de Ioana Orleanu <br>\n\u201EArs\u201C, 1-2/2010, Podgorica, Muntenegru, traducere de Ivana Oluji\u0107 <br>\n\u201ECrosspoint\u201C, noiembrie 2010, traducere \xEEn limba bulgar\u0103 de Lora Nenkovska <br>\n\u201ENagyvil\xE1g\u201C, nr 9, septembrie 2010, Budapesta, traducere \xEEn limba maghiar\u0103 de L\xF6vetei L\xE1z\xE1r L\xE1szlo <br>\n\u201ELe Fram\u201C, nr. 22, martie/2011, Li\xE8ge, traducere \xEEn limba francez\u0103 de Jan H. Mysjkin <br>\n\u201EPoeziekrant\u201C, nr 3, 2011, Gent,  traducere \xEEn neerlandez\u0103 de Jan H. Mysjkin <br>\n\u201EAsymptote\u201C, Singapore, aprilie 2011, traducere \xEEn limba englez\u0103 de Florin Bican: <a href=\'http://asymptotejournal.com/article.php?cat=Poetry&id=27&curr_index=2&curPage=Poetry\' target=\'_blank\'>www.asymptotejournal.com</a> <br>\n<br><br>\nPoetry International festival Rotterdam: <a href=\'http://www.poetryinternational.org\' target=\'_blank\'>www.poetryinternational.org</a> <br>\n<br><br>\nVolume individuale traduse: <br><br>\n\nHet juffertje van marsepein (Duduca de mar\u0163ipan), \xEEn neerlandez\u0103 de Jan H. Mysjkin, Editura Douane, Rotterdam, 2011 <br>\nLa demoiselle de massepain (Duduca de mar\u0163ipan), volum bilingv tradus de Jan H. Mysjkin, \xC9ditions Atelier de l\u2019agneau, 2013 <br>\nRythmes pour apprivoiser la h\xE9rissonne (Ritmuri de \xEEmbl\xEEnzit aricioaica), volum tradus de Jan H. Mysjkin, \xC9ditions L\u2019Arbre \xE0 paroles, Amay, 2013 <br>\n[Ultimele dou\u0103 volume au ap\u0103rut cu ocazia Salon du Livre de Paris, 2013] <br>\nOorbellen, buiken en eenzaamheid (E vremea s\u0103 por\u0163i cercei, Cartea bur\u0163ilor \u015Fi a singur\u0103t\u0103\u0163ii), volume traduse \xEEn neerlandez\u0103 de Jan H. Mysjkin, Editura Perdu, Amsterdam, 2013, <br>\nRitmen om de vrouwtjesegel te temmen (Ritmuri de \xEEmbl\xEEnzit aricioaica), tradus \xEEn neerlandez\u0103 de Jan H. Mysjkin,  Editura De Contrabas, Utrecht, 2014 <br>\nBoucles d\'oreilles, ventres et solitude (E vremea s\u0103 por\u0163i cercei, Cartea bur\u0163ilor \u015Fi a singur\u0103t\u0103\u0163ii), volume bilingve, traduse de Jan H. Mysjkin,  \xC9ditions Cheyene, 2014 <br>\nCoutures (Cus\u0103turi), volum tradus de Jan H. Mysjkin, \xC9ditions L\u2019Arbre \xE0 paroles, Amay, 2015 <br>\n\n\n<br><br>\n\nUnul dintre poemele din Ritmuri de \xEEmbl\xEEnzit aricioaica, sub titlul The Yellow Dog, a intrat \xEEn topul celor mai frumoase poezii de dragoste, \xEEn selec\u0163ia celor de la Southbank Centre din Londra. <br>\n\nVolumul Boucles d\'oreilles, ventres et solitude (E vremea s\u0103 por\u0163i cercei, Cartea bur\u0163ilor \u015Fi a singur\u0103t\u0103\u0163ii), edi\u0163ie bilingv\u0103, volum tradus de Jan H. Mysjkin,  \xC9ditions Cheyene, 2014,  a fost nominalizat la Le Prix des D\xE9couvreurs 2017. <br>\n\nDoina Ioanid a fost asistent universitar la catedra de Limbi Str\u0103ine a Facult\u0103\u021Bii de Litere, Universitatea \u201ETransilvania\u201C Bra\u015Fov, \xEEntre anii 1998-2005. Apoi a devenit secretar de redac\u0163ie la Observator cultural (2005-2014). \xCEn prezent, este redactor la aceea\u015Fi revist\u0103. <br>',
        'Nicoleta Popa Blanariu': 'Nicoleta Popa Blanariu este conferen\u0163iar universitar la Facultatea de Litere a Universit\u0103\u0163ii \u201EVasile Alecsandri\u201D din Bac\u0103u, unde pred\u0103 literatur\u0103 comparat\u0103, literatur\u0103 rom\xE2n\u0103 \u015Fi alte discipline aflate \xEEn zona de interferen\u0163\u0103 a studiilor literare cu \u015Ftiin\u0163ele comunic\u0103rii \u015Fi ale limbajului, cu artele spectacolului \u015Fi antropologia cultural\u0103. \xCEn aceast\u0103 zon\u0103 interdisciplinar\u0103 se situeaz\u0103 volumele C\xE2nd gestul rupe t\u0103cerea. Dansul \u015Fi paradigmele comunic\u0103rii (Ia\u015Fi, \u201EFides\u201D, 2008), C\xE2nd literatura comparat\u0103 pretinde c\u0103 se destram\u0103. Studii \u015Fi eseuri (vol. I: Invarian\u0163ii, un fir al Ariadnei?, vol. II: (Inter)text \u015Fi (meta)spectacol, Bucure\u015Fti, \u201EEikon\u201D, 2016). Este, de asemenea, coautor al mai multor volume colective ap\u0103rute la edituri din Statele Unite, Marea Britanie, Australia, Italia. A publicat articole \xEEn reviste \u015Ftiin\u0163ifice din Spania, India, Statele Unite, Rom\xE2nia \u015Fi \xEEn presa cultural\u0103 (Ateneu, Vitraliu).  A  cotradus din limba francez\u0103 Dic\u0163ionarul de teatru al lui Patrice Pavis (Ia\u015Fi, \u201EFides\u201D, 2012). Este membr\u0103 \xEEn consiliul editorial al Southern Semiotic Review (Sydney, Australia) \u015Fi al revistei Studii \u015Fi cercet\u0103ri \u015Ftiin\u0163ifice, seria filologie. \n\n<br><br>\n<a href=\'https://ub-ro.academia.edu/NicoletaPopaBlanariu/CurriculumVitae\' target=\'_blank\'>CurriculumVitae</a>\n<br><br>\n<a href=\'https://ub-ro.academia.edu/NicoletaPopaBlanariu\' target=\'_blank\'>https://ub-ro.academia.edu/NicoletaPopaBlanariu</a>\n<br><br>'
      }
    },
    EN: {
      menu: {
        about: 'about',
        contest: 'contest',
        archive: 'archive',
        contact: 'contact'
      }
    }
  },
  svg: {
    flags: {
      RO: '<svg width=\'40px\' height=\'24px\' viewBox=\'0 0 40 24\' version=\'1.1\' xmlns=\'http://www.w3.org/2000/svg\' xmlns:xlink=\'http://www.w3.org/1999/xlink\'>\n    <!-- Generator: Sketch 48 (47235) - http://www.bohemiancoding.com/sketch -->\n    <desc>Created with Sketch.</desc>\n    <defs></defs>\n    <g id=\'Page-1\' stroke=\'none\' stroke-width=\'1\' fill=\'none\' fill-rule=\'evenodd\'>\n        <g id=\'ro-flag\' fill-rule=\'nonzero\'>\n            <rect id=\'Rectangle-path\' fill=\'#002B7F\' x=\'0\' y=\'0\' width=\'40\' height=\'24\'></rect>\n            <rect id=\'Rectangle-path\' fill=\'#FCD116\' x=\'13.3333333\' y=\'0\' width=\'26.6666667\' height=\'24\'></rect>\n            <rect id=\'Rectangle-path\' fill=\'#CE1126\' x=\'26.6666667\' y=\'0\' width=\'13.3333333\' height=\'24\'></rect>\n        </g>\n    </g>\n</svg>',
      EN: '<svg width=\'44px\' height=\'30px\' viewBox=\'0 0 44 30\' version=\'1.1\' xmlns=\'http://www.w3.org/2000/svg\' xmlns:xlink=\'http://www.w3.org/1999/xlink\'>\n    <desc>Created with Sketch.</desc>\n    <defs>\n        <path d=\'M20,12 L40,12 L40,24 L20,12 Z M20,12 L20,24 L0,24 L20,12 Z M20,12 L0,12 L0,0 L20,12 Z M20,12 L20,0 L40,0 L20,12 Z\' id=\'path-1\'></path>\n    </defs>\n    <g id=\'Page-1\' stroke=\'none\' stroke-width=\'1\' fill=\'none\' fill-rule=\'evenodd\'>\n        <g id=\'uk-flag\' transform=\'translate(2.000000, 3.000000)\'>\n            <polygon id=\'Shape\' fill=\'#00247D\' fill-rule=\'nonzero\' points=\'0 0 0 24 40 24 40 0\'></polygon>\n            <path d=\'M0,0 L40,24 M40,0 L0,24\' id=\'Shape\' stroke=\'#FFFFFF\' stroke-width=\'6\' fill=\'#000000\' fill-rule=\'nonzero\'></path>\n            <g id=\'Clipped\'>\n                <mask id=\'mask-2\' fill=\'white\'>\n                    <use xlink:href=\'#path-1\'></use>\n                </mask>\n                <g id=\'Shape\'></g>\n                <path d=\'M0,0 L40,24 M40,0 L0,24\' id=\'Shape\' stroke=\'#CF142B\' stroke-width=\'4\' fill=\'#000000\' fill-rule=\'nonzero\' mask=\'url(#mask-2)\'></path>\n            </g>\n            <path d=\'M20,0 L20,24 M0,12 L40,12\' id=\'Shape\' stroke=\'#FFFFFF\' stroke-width=\'10\' fill=\'#000000\' fill-rule=\'nonzero\'></path>\n            <path d=\'M20,0 L20,24 M0,12 L40,12\' id=\'Shape\' stroke=\'#CF142B\' stroke-width=\'6\' fill=\'#000000\' fill-rule=\'nonzero\'></path>\n        </g>\n    </g>\n</svg>'
    }
  },
  contact: {
    form: {
      name: '',
      email: '',
      msg: ''
    },
    isSent: false
  },
  streetart: {
    isSent: false
  },
  voluntar: {
    form: {
      prenume: '',
      nume: '',
      varsta: '',
      email: '',
      dece: '',
      tel: '',
      limbi: '',
      categorie: ''
    },
    isForm: true,
    msg: {
      success: 'Mul\u0163umim pentru timpul acordat \u015Fi dorin\u0163a de implicare \xEEn Programul de Voluntariat Blecher Fest 2018!\n      Completarea acestui formular este un prim pas, urmat de o \xEEnt\xE2lnire informal\u0103 dac\u0103 vei fi selectat \u0219i o serie de sesiuni de preg\u0103tire.\n      *Minorii se angajeaz\u0103 s\u0103 nu consume b\u0103uturi alcoolice.',
      error: 'Mesajul nu a putut fi trimis datorit\u0103 unei erori tehnice. V\u0103 rug\u0103m s\u0103 ne contacta\u021Bi pentru a remedia defec\u021Biunea. V\u0103 mul\u021Bumim.'
    },
    sentMsg: ''
  },
  socialMedia: {
    fb: 'https://www.facebook.com/blecherfest.ro/'
  },
  program: {
    vineri: [{
      img: 'opening',
      location: 'Colegiul Național Roman-Vodă',
      zi: 'Vineri',
      name: 'Deschidere Blecher Fest',
      description: 'Întâlnire pe treptele Liceului Roman-Vodă',
      time: '17:00'
    }, {
      img: 'casa-hogas',
      location: 'Muzeul "Casa Hogaș"',
      zi: 'Vineri',
      name: 'Mărturii vizuale despre M. Blecher',
      description: 'Expoziție de documente bibliofile, fotografii și lucrări de artă despre M.Blecher.',
      time: '17:30'
    }, {
      img: 'trupa-percutie',
      location: 'Colegiul Național Roman-Vodă',
      zi: 'Vineri',
      name: 'Concert live percuție',
      description: 'Trupa de percuție Gh. Dima din Piatra Neamț',
      time: '19:00'
    }],
    sambata: [{
      img: 'lansare-carte-1',
      location: 'Biblioteca Municipală "George Radu Melidon"',
      zi: 'Sambata',
      name: 'Lansare de carte - Doris Mironescu',
      description: 'Lansarea volumelor criticului literar Doris Mironescu: \u201EVia\u021Ba lui M. Blecher, \xEEmpotriva biografiei\u201D, edi\u021Bia a doua, Humanitas, 2018; M. Blecher, \u201EOpere\u201D, edi\u021Bie critic\u0103 realizat\u0103 la Funda\u021Bia Na\u021Bional\u0103 pentru \u0218tiin\u021B\u0103 \u0219i Art\u0103, 2017.\nInvita\u021Bi: criticii literari Nicoleta Popa Blanariu, Adrian Jicu, Adrian G. Romila',
      time: '10:00'
    }, {
      img: 'gps',
      location: 'Biblioteca Municipală "George Radu Melidon"',
      zi: 'Sambata',
      name: 'GPS Literar',
      description: 'Pe un traseu care pornește de la Bibllioteca Municipală Roman, și care va continua apoi pe strada Ștefan cel Mare, cu opriri în diferite locuri, actorii vor pune în scenă pagini din opera lui M. Blecher chiar în spațiile care, cu probabilitate, l-au inspirat pe scriitor. <br> Spectatorii sunt invitați să asocieze locuri cunoscute ale orașului cu viziunile filtrate prin imaginația scriitorului interbelic.',
      time: '11:30'
    }, {
      img: 'casa-hogas',
      location: 'Muzeul Casa Hogaș',
      zi: 'Vineri',
      name: 'Mărturii vizuale despre M. Blecher',
      description: 'Expoziție de documente bibliofile, fotografii și lucrări de artă despre M.Blecher.',
      time: '14:00'
    }, {
      img: 'meridiane',
      location: 'Sala "Nicolae Manolescu Strunga" a Primăriei Roman',
      zi: 'Sambata',
      name: 'M. Blecher pe meridianele lumii',
      description: 'Masă rotundă cu traducătorii operei lui M. Blecher: Bruno Mazzoni (Italia), Fernando Klabin (Brazilia), Joanna Kornas-Warwas (Polonia), Jan H. Mysjkin (Belgia). ',
      time: '15:00'
    }, {
      img: 'momo-workshop',
      location: 'Kult Hub',
      zi: 'Sambata',
      name: 'Workshop de miscare cu Momo Sanno',
      description: 'http://www.momosanno.com/',
      time: '16:00'
    }, {
      img: 'colosseum',
      location: 'Curtea Bibilotecii Municipale',
      zi: 'Sambata',
      name: 'Colosseum Quartet - Iași',
      description: 'Concert de muzică clasică',
      time: '17:00'
    }, {
      img: 'urletul',
      location: 'Casa Romașcană',
      zi: 'Sambata',
      name: 'Performance URLETUL',
      description: 'Urletul de Allen Ginsberg cu Ionuț Caras și Vasile Gherghel',
      time: '20:00'
    }, {
      img: 'feri',
      location: 'Casa Romașcană',
      zi: 'Sambata',
      time: '21:30',
      name: 'Égvilág Ségerczferi trio',
      description: 'concert de muzică românească, cu artistul Ferenc Ségercz și noul său trio'
    }, {
      img: 'trei-parale',
      location: 'Casa Romașcană',
      zi: 'Sambata',
      name: 'Concert Trei Parale',
      description: 'concert de muzică veche românească',
      time: '22:30'
    }],
    duminica: [{
      img: 'cimitir',
      location: 'Cimitirul Evreiesc',
      zi: 'Duminica',
      name: 'Memento M. Blecher',
      description: 'Prezentare a istoriei comunității evreiești din Roman; reculegere la mormântul lui M. Blecher; comemorare a marelui scriitor prin lecturi, recitări, alocuțiuni.',
      time: '10:00'
    }, {
      img: '',
      location: 'Sala Primăriei',
      zi: 'Duminica',
      name: 'Festivitate Premiere',
      time: '13:00',
      description: 'Premierea câștigătorilor concursului de creație Max Blecher.'
    }, {
      img: 'casa-hogas',
      location: 'Muzeul Casa Hogaș',
      zi: 'Vineri',
      name: 'Mărturii vizuale despre M. Blecher',
      description: 'Expoziție de documente bibliofile, fotografii și lucrări de artă despre M.Blecher.',
      time: '15:00'
    }, {
      img: '',
      location: '',
      zi: 'Duminica',
      name: 'Deschidere evenimente stradale',
      description: 'Strada Ștefan cel Mare ce va fi închisă circulației automobilelor și deschisă evenimentelor artistice stradale.',
      time: '16:00'
    }, {
      img: 'momo-workshop-CR',
      location: 'Casa Romașcană',
      zi: 'Duminica',
      name: 'Workshop de miscare cu Momo Sanno',
      description: 'http://www.momosanno.com/',
      time: '16:30'
    }, {
      img: '',
      location: 'Str. Ștefan cel Mare (Casa Romașcană)',
      zi: 'Duminica',
      name: 'Trupa de teatru „Gong”, Roman',
      description: 'Spectacol de pantomimă',
      time: '17:45'
    }, {
      img: 'miky',
      location: 'str. Ștefan cel Mare',
      zi: 'Sambata',
      name: 'Atelier desen stradal, Miki Moraru',
      description: '',
      time: '18:00'
    }, {
      img: 'momo-performance',
      location: 'Casa Romașcană',
      zi: 'Duminica',
      name: 'Performance de miscare cu Momo Sanno',
      description: 'Spectacol de dans stradal',
      time: '20:00'
    }, {
      img: 'pink',
      location: 'Casa Roma\u0219can\u0103',
      zi: 'Duminica',
      name: 'Concert Fine, It\'s Pink',
      description: '',
      time: '21:00'
    }]
  }
};

var getters = {
  lang: function lang(state) {
    return localStorage.getItem('bfLang');
  },
  content: function content(state) {
    return state.content[localStorage.getItem('bfLang')];
  },
  svg: function svg(state) {
    return state.svg;
  },
  contact: function contact(state) {
    return state.contact;
  },
  socialMedia: function socialMedia(state) {
    return state.socialMedia;
  },
  isContestUploadSuccess: function isContestUploadSuccess(state) {
    return state.isContestUploadSuccess;
  },
  voluntar: function voluntar(state) {
    return state.voluntar;
  },
  isModal: function isModal(state) {
    return state.isModal;
  },
  streetart: function streetart(state) {
    return state.streetart;
  },
  program: function program(state) {
    return state.program;
  }
};

var actions = {
  stop_scroll: function stop_scroll(_ref, payload) {
    var state = _ref.state;

    if (state.top === 0) {
      state.top = document.documentElement.scrollTop || document.body.scrollTop;
    }
    setTimeout(function () {
      document.getElementById('app').style.overflow = payload ? 'hidden' : 'visible';
    }, 300);
    !payload && window.scroll(0, state.top);
  },
  submit_lucrare_concurs: function submit_lucrare_concurs(_ref2, data) {
    var commit = _ref2.commit;

    var url = 'https://www.electronlabs.ro/docs';
    __WEBPACK_IMPORTED_MODULE_4_axios___default()({
      url: url,
      method: 'POST',
      headers: { 'Content-Type': undefined },
      data: data
    }).then(function (resp) {
      // mesaj de succes
      commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["b" /* SET_CONTEST_MSG */], 'success');
    }).catch(function (err) {
      console.log(err);
      // mesaj de eroare
    });
  },
  send_msg: function send_msg(_ref3) {
    var state = _ref3.state;

    __WEBPACK_IMPORTED_MODULE_4_axios___default()({
      url: 'static/sendMsg.php',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      data: state.contact.form
    }).then(function (resp) {
      resp.status === 200 && __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(state.contact, 'isSent', true);
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(state.contact.form).forEach(function (val) {
        __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(state.contact.form, val, '');
      });
    });
  },
  submit_voluntar: function submit_voluntar(_ref4) {
    var commit = _ref4.commit;

    __WEBPACK_IMPORTED_MODULE_4_axios___default()({
      url: 'https://www.electronlabs.ro/voluntar',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      data: state.voluntar.form
    }).then(function (resp) {
      commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["e" /* SET_VOLUNTAR_FORM_STATE */], 'success');
    }).catch(function (err) {
      commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["e" /* SET_VOLUNTAR_FORM_STATE */], 'error');
      console.log(err.response);
    });
  },
  submit_streetart: function submit_streetart(_ref5, payload) {
    var commit = _ref5.commit;

    __WEBPACK_IMPORTED_MODULE_4_axios___default()({
      url: 'static/sendStreetArt.php',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      data: payload
    }).then(function (resp) {
      resp.status === 200 && __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(state.streetart, 'isSent', true);
    }).catch(function (e) {
      console.log(e);
    });
  },
  get_press: function get_press(_ref6) {
    var commit = _ref6.commit;

    __WEBPACK_IMPORTED_MODULE_4_axios___default()('https://www.electronlabs.ro/press').then(function (resp) {
      commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["a" /* SET_CONTENT */], {
        section: 'press',
        data: resp.data.rows
      });
    }).catch(function (err) {
      console.log(err.response);
    });
  },
  get_invitati: function get_invitati(_ref7) {
    var commit = _ref7.commit;

    __WEBPACK_IMPORTED_MODULE_4_axios___default()('https://www.electronlabs.ro/invitati').then(function (resp) {
      var invitati = __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.sortBy(resp.data.rows, 'value.numar_ordine');
      commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["a" /* SET_CONTENT */], { section: 'invitati', data: invitati });
    }).catch(function (err) {
      console.log(err.response);
    });
  },
  get_program: function get_program(_ref8) {
    var commit = _ref8.commit;

    __WEBPACK_IMPORTED_MODULE_4_axios___default()('https://www.electronlabs.ro/program').then(function (resp) {
      commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["d" /* SET_PROGRAM */], resp.data.rows);
    }).catch(function (err) {
      console.log(err.response);
    });
  },
  FB_Parse: function FB_Parse() {
    setTimeout(function () {
      window.FB.XFBML.parse();
    }, 10);
  }
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["b" /* SET_CONTEST_MSG */], function (state, msg) {
  state.isContestUploadSuccess = msg === 'success';
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["e" /* SET_VOLUNTAR_FORM_STATE */], function (state, msg) {
  __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(state.voluntar, 'isForm', false);
  __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(state.voluntar, 'sentMsg', state.voluntar.msg[msg]);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["a" /* SET_CONTENT */], function (state, _ref9) {
  var section = _ref9.section,
      data = _ref9.data;

  __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(state.content[localStorage.getItem('bfLang')], section, data);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["d" /* SET_PROGRAM */], function (state, data) {
  data.forEach(function (obj) {
    delete obj.value._id;
    delete obj.value._rev;
    __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(state.content[localStorage.getItem('bfLang')].program, obj.id, obj.value);
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["c" /* SET_MODAL */], function (state) {
  state.isModal = !state.isModal;
}), _mutations);

var store = new __WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* default */].Store({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});
Object(__WEBPACK_IMPORTED_MODULE_7__store_moderator__["a" /* default */])(store, __WEBPACK_IMPORTED_MODULE_8__router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14cb1613_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("ynoy");
function injectStyle (ssrContext) {
  __webpack_require__("fhYt")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14cb1613_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_clip__ = __webpack_require__("qJAx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_clip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_clip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vee_validate__ = __webpack_require__("sUu7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_molecules_BaseMainMenu__ = __webpack_require__("7yX/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_base_sass__ = __webpack_require__("qrU6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_base_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__styles_base_sass__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.






// import runtime from 'serviceworker-webpack-plugin/lib/runtime'



// if ('serviceWorker' in navigator) {
//   const registration = runtime.register()
//   console.log(registration)
// }

/* COMPONENTS */
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('main-menu', __WEBPACK_IMPORTED_MODULE_6__components_molecules_BaseMainMenu__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue_clip___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vee_validate__["a" /* default */]);
var dict = {
  custom: {
    email: {
      required: 'Câmpul email este obligatoriu.',
      email: 'Formatul adresei email nu este valid (ex: a@a.aa)'
    },
    nume: {
      required: 'Câmpul nume este obligatoriu.'
    },
    prenume: {
      required: 'Câmpul prenume este obligatoriu.'
    },
    oras: {
      required: 'Câmpul oraș este obligatoriu.'
    },
    categorie: {
      required: 'Câmpul categorie este obligatoriu.'
    },
    anexe: {
      required: 'Câmpul anexe este obligatoriu.'
    },
    lucrare: {
      required: 'Câmpul lucrare este obligatoriu.'
    },
    varsta: {
      required: 'Câmpul varsta este obligatoriu.'
    },
    phone: {
      required: 'Câmpul telefon este obligatoriu.'
    },
    dece: {
      required: 'Câmpul este obligatoriu.'
    },
    descriere: {
      required: 'Câmpul descriere este obligatoriu.'
    },
    proiect: {
      required: 'Câmpul proiect este obligatoriu.'
    },
    tel: {
      required: 'Câmpul telefon este obligatoriu.'
    }
  }
};
__WEBPACK_IMPORTED_MODULE_5_vee_validate__["a" /* default */].Validator.localize('en', dict);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  created: function created() {
    (function (d, s, id) {
      var js;
      var fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) return;
      js = d.createElement(s);
      js.id = id;
      js.src = '//connect.facebook.net/en_US/sdk.js#xfbml=1&version=v2.9';
      fjs.parentNode.insertBefore(js, fjs);
    })(document, 'script', 'facebook-jssdk');
  },
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

/***/ }),

/***/ "Pj5g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = configureModerator;
function configureModerator(store, router) {
  // listen to mutations
  store.subscribe(function (_ref, state) {
    var type = _ref.type,
        payload = _ref.payload;

    console.log('mutation', type);
    switch (type) {
      case 'auth/setToken':
        return store.dispatch('service/fetchData');
      default:
      // console.log('mutation', type)
    }
  });
  // listen to actions
  // note: doesn't not wait for the result of async actions
  store.subscribeAction(function (_ref2, state) {
    var type = _ref2.type,
        payload = _ref2.payload;

    // console.log('actions', type)
    switch (type) {
      case 'auth/signOut':
        return router.push('/auth/signin');
      default:
      // console.log('actions', type)
    }
  });
}

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");


// import Home from '@/components/Home'
// import Contests from '@/components/Contests'
// import Invitati from '@/components/Invitati'
// import Program from '@/components/Program'
// import Press from '@/components/Press'
// import Archive from '@/components/Archive'
// import Voluntar from '@/components/Voluntar'
// import Contact from '@/components/Contact'
// import Echipa from '@/components/Echipa'
// import Parteneri from '@/components/Parteneri'
// import StreetArt from '@/components/StreetArt'

var Home = function Home() {
  return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, "lO7g"));
};
var Contests = function Contests() {
  return __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, "oaXV"));
};
var Invitati = function Invitati() {
  return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, "U89e"));
};
var Program = function Program() {
  return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, "VY5o"));
};
var Press = function Press() {
  return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, "jpXq"));
};
var Archive = function Archive() {
  return __webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, "QfD2"));
};
var Voluntar = function Voluntar() {
  return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, "LYx7"));
};
var Contact = function Contact() {
  return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, "FnhZ"));
};
var Echipa = function Echipa() {
  return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, "sQ3F"));
};
var Parteneri = function Parteneri() {
  return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, "tzQb"));
};
var StreetArt = function StreetArt() {
  return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, "qUES"));
};
var Photos = function Photos() {
  return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, "stTf"));
};

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/',
    redirect: '/about'
  }, {
    path: '/about',
    name: 'about',
    component: Home
  }, {
    path: '/concurs',
    name: 'concurs',
    component: Contests
  }, {
    path: '/invitati',
    name: 'invitati',
    component: Invitati
  }, {
    path: '/invitati/:name',
    name: 'invitati',
    component: Invitati
  }, {
    path: '/program',
    name: 'program',
    component: Program
  }, {
    path: '/press',
    name: 'press',
    component: Press
  }, {
    path: '/archive',
    name: 'archive',
    component: Archive
  }, {
    path: '/echipa',
    name: 'echipa',
    component: Echipa
  }, {
    path: '/voluntar',
    name: 'voluntar',
    component: Voluntar
  }, {
    path: '/parteneri',
    name: 'parteneri',
    component: Parteneri
  }, {
    path: '/contact',
    name: 'contact',
    component: Contact
  }, {
    path: '/streetart',
    name: 'street-art',
    component: StreetArt
  }, {
    path: '/photos',
    name: 'photos',
    component: Photos
  }],
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {}
});

router.beforeEach(function (to, from, next) {
  !localStorage.getItem('bfLang') && localStorage.setItem('bfLang', 'RO');
  next();
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ "cCwy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"main-menu flex flex-between fixed w100 top0 z10 bg-white z9999",class:{'mobile-menu': _vm.isMobileMenu}},[_c('router-link',{staticClass:"logo absolute",attrs:{"to":"/"}},[_c('img',{staticClass:"w100",attrs:{"src":__webpack_require__("7Otq"),"alt":"logo"}})]),_vm._v(" "),_c('nav',{staticClass:"items z9999 hide"},[_vm._l((_vm.content.menu),function(item,key){return _c('router-link',{key:key,staticClass:"uppercase",attrs:{"to":'/' + key}},[_c('span',{on:{"click":_vm.Set_Route}},[_vm._v(_vm._s(item))])])}),_vm._v(" "),_c('nav',{staticClass:"flags absolute hide"},[_c('ul',{staticClass:"flex"},_vm._l((_vm.svg.flags),function(item,key){return _c('li',{key:key,staticClass:"pointer"},[(key !== _vm.lang)?_c('i',{domProps:{"innerHTML":_vm._s(item)}}):_vm._e()])}))])],2),_vm._v(" "),_c('nav',{staticClass:"social flex absolute z999"},[_c('a',{attrs:{"href":_vm.socialMedia.fb,"target":"_blank"}},[_c('img',{attrs:{"src":__webpack_require__("pUJY"),"alt":"fb"}})])]),_vm._v(" "),_c('div',{staticClass:"menu-icon z9999 absolute",on:{"click":_vm.ShowMobileMenu}},[_c('svg',{attrs:{"width":"32px","height":"22px","viewBox":"274 37 32 22"}},[_c('g',{attrs:{"id":"Group-4","stroke-width":"1","fill":"none","fill-rule":"evenodd","transform":"translate(275.000000, 38.000000)"}},[_c('path',{staticClass:"line",attrs:{"d":"M0,1 L29.367867,1","id":"line-1","stroke-width":"2"}}),_vm._v(" "),_c('path',{staticClass:"line",attrs:{"d":"M0,10 L29.367867,10","id":"line-2","stroke-width":"2"}}),_vm._v(" "),_c('path',{staticClass:"line",attrs:{"d":"M0,18 L29.367867,18","id":"line-3","stroke-width":"2"}})])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "eyuN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fhYt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pUJY":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOEAAADhCAMAAAAJbSJIAAAAclBMVEU8Wpn////y9PgiSZE5WJhQaaLX3OgoTZLt7/QwUpU0VJahrMiGlLo2VpceR5B9jbbT2OVzhbHd4ev5+vyLmb3k5+9FYZ26wtfL0eBnfKuYpMRKZZ+qtM6gq8h+jrZZcKUAOoq+xtlWbqRgdqi6wtaToMF2KukBAAAETElEQVR4nO3d63aiMBSGYTBRDJoIHms9TWu9/1scW0dqHcdsiSHszPf+mV+z5FmiVHIgSWMvCX0A3vv/hB3+3REW07kREbQ69G4Ke12RyySGpBK78d/Cg9Ghj+yJSTO4Fo6y0Af15MT0p/AQG/BIXF8KCxP6eDxkZhfCbkyfwXN6+S0sROij8dLpTfwSTvPQB+MltamE8ziug9fJfSWM8Xsm+bzyn4WdOD+GxwsGhOyDkH8Q8g9C/kHIPwj5ByH/IOQfhPyDsAVpnZ/SudZSy+Sxm4JtFspcZcIku3I0nB4bbkflcv++SpQxQmRZplSu7drWClVmutNF0U9vNenMxsXbejMt363EVgqlEsnhZXITd531Vn0LhTLLfoxQ32/ITiiz+YLMYyg8+t4e8bET6mz9mI+bUJS0bxeuQmke+gDyE2o9qwFkJMy7j5+hrIRqX8vHR5jvagK5COW8LpCLMLueLRmb0BS1gTyE6rU+kIVQrhyALIRmbEFwF+ZDFyAHoan/PcpDmB+cgAyEjm9h+4X51g3YfqGg33PiKXS7FnIQqoEFwF4oav2uZyR0+NXERKgcL4btF2YvzsKWj1sI+uV+0vsYHIbb7ehU9W/XNvgU+HNI5a33IlOf44VVf0ZN7WsJgwp1SQNuhKq/GCSokPbjvrNSLi8SVvhBAeZuK86CCjPKHah3xyV1QYXi9ij9jxauyz7DCglDFQ/OLbnxIkGFdqD7qsiQQpnbha/OqyKDvoeEv7v3zqsig76HhJ+/7svLgwq7VuDE/ahaLpxFLxxHf5b2ILQHoc8ghJAWhD6DEEJaEPoMQghpQegzCCGkBaHPIGQiVHd2wrXv0Fz8smymG36VrHrt9P+dVTi5858/m1gnKvgXOk/rup/9LGYuJBw1cyHhnjhz4Vv0wrV9IgpzIWHjXObC0j4VhbmQsDUwcyHhoHkL+9ELKX+Y8xYSLofMhQPCvEzeQus0dvZCyowp3kLKlDDeQsoxsxZSLoe8hQXlPhVr4YIyiZ+1cBO9cEuZxs9auIteSForxFlIm0DMWUibQMxZ+EIatuEsJF0OWQtpq004C8vohfaRtSaE+cafkDY+HHIM2DiOAdOWRGEc32cQQkgLQp9BCCEtCH0GIYS0IPQZhBDSgtBnEEJIC0KfQQghLQh9BiGEtCD0GYQQ0oLQZxBCSAtCn0EIIS0IfQYhhLQg9BmEENKC0GcQQkgLQp9BCCEtCH0GIYS0IPQZhBDSgtBnEEJIC0KfQQghrUpI2t3tuTUiPD2w9ku4cn5q68Mv3oRQLyvhwekJ5nVqRHjaeuRL2Gv8NG1EaPqVMN01fZo2IdRl+i0cm6ccN70mhKe38I8wHTR8njYgNIv0UphOmyX6F5rz/j/VTjhrQ9mn71n5FurzO3ghTGdLo2RT3zg+hVIrU34/5eVyN6PZZn/v4TfPzHUXpXvly8HlU2zsr8Q9CPkXv/A3+sZjUOLI4n0AAAAASUVORK5CYII="

/***/ }),

/***/ "qrU6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rSAv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'BaseMainMenu',
  data: function data() {
    return {
      isMobileMenu: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['lang', 'svg', 'content', 'socialMedia'])),
  methods: {
    ShowMobileMenu: function ShowMobileMenu() {
      this.isMobileMenu = !this.isMobileMenu;
    },
    Set_Route: function Set_Route() {
      this.isMobileMenu = false;
    }
  }
});

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app'
});

/***/ }),

/***/ "ynoy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"wh100",attrs:{"id":"app"}},[_c('main-menu'),_vm._v(" "),_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.c6e889feb3e0d44b9151.js